<template>
    <div
        class="cms-content-column cms-content-our-range__no-special-offer cms-content-our-range__container"
        :class="{'cms-content-our-range__container--hidden' : (hideResults && index >= 3 )}"
    >
        <a
            :href="vehicle.route"
            v-on:click="(event) => {
                event.preventDefault();
                analyticsEvent({
                    category: 'New Model Search',
                    label: 'Car Image',
                    action: `Clicked`,
                }, event);
            }"
        >
            <picture class="cms-content-our-range__image">
                <source :srcset="vehicle.image_webp" type="image/webp" />
                <img
                    :src="vehicle.image"
                    :alt="vehicle.short_name"
                    class="cms-content-our-range__image"
                />
            </picture>
        </a>
        <div class="rd-card cms-content-our-range__card">
            <!-- <div class="cms-content-our-range__available-electric">
                <div v-if="vehicle.fuel_type === 'Electric'"  class="cms-content-our-range__has-electric">Available in Electric <img src="/images/new/details/electric-btn-icon.svg" alt="" class="cms-content-our-range__has-electric-icon"></div>
            </div> -->
            <h2 class="cms-content-slice__trim-name">
                {{ vehicle.model_title }}
            </h2>
            <div class="cms-content-our-range__finance-wrapper">
                <div
                    :class="{
                        'cms-content-our-range__flex-row': true,
                        'cms-content-our-range__flex-row--with-border':
                            (vehicle.finance_type == 'car' && vehicle.hide_finance == 0),
                    }"
                >
                    <p>Vehicle Price from</p>
                    <p>
                        <span class="cms-content-price cms-content-price--orange">
                            {{ formattedPrice }}
                        </span>
                    </p>
                </div>
                <span
                    v-if="type == 'Car' && vehicle.hide_finance == 0"
                    class="trim-box-finance-area"
                    :data-id="vehicle.finance_id"
                    :data-manufacturer="vehicle.manufacturer"
                    :data-brand="vehicle.finance_brand"
                    :data-quote-valid-date="quoteValidDate"
                    :data-price="vehicle.pricing_display_price"
                    :data-retail="vehicle.retail"
                    :data-identifier="identifier"
                    :data-identifier-type="identifierType"
                    :data-link="vehicle.finance_link"
                    :data-type="type"
                    :data-price_HP="vehicle.price_HP"
                    :data-price_HPSTANDARD="vehicle.price_HPSTANDARD"
                    :data-price_PCP="vehicle.price_PCP"
                ></span>
            </div>
            <a
                class="btn btn--primary btn--full-width cms-content-our-range__offers-button"
                :href="vehicle.route"
                v-on:click="(event) => {
                    event.preventDefault();
                    analyticsEvent({
                        category: 'New Model Search',
                        label: 'View More CTA',
                        action: `Clicked`,
                    }, event);
                }"
            >
                View More
            </a>
            <a
                v-if="showTestDrive"
                class="link link--has-icon link--centered cms-content-our-range__test-drive-button"
                :href="vehicle.configurator"
                v-on:click="(event) => {
                    event.preventDefault();
                    analyticsEvent({
                        category: 'New Model Search',
                        label: 'Configure Now CTA',
                        action: `Clicked`,
                    }, event);
                }"
            >
                Configure Now
            </a>
            <div v-else class="cms-content-our-range__test-drive-button cms-content-our-range__test-drive-button--placeholder"></div>
        </div>
    </div>
</template>

<script>
import NumberFormat from "../../../used-vue/api/NumberFormat";
import { customEvent } from "../../../modules/tracking/AnalyticsEvents";
import { mapState } from "vuex";

export default {
    props: {
        vehicle: Object,
        index: Number,
        hideResults: false
    },
    computed: {
        ...mapState(["quoteValidDate"]),
        formattedPrice() {
            return `£${NumberFormat(this.vehicle.pricing_display_price)}`;
        },
        identifier() {
            if (this.vehicle.titre_code != "") {
                return this.vehicle.titre_code;
            }
            return this.vehicle.cap_id;
        },
        identifierType() {
            if (this.vehicle.titre_code != "") {
                return "Titre";
            }
            return "CapShortCode";
        },
        type() {
            if (this.vehicle.finance_type == "car") {
                return "Car";
            }
            return "Lcv";
        },
        showTestDrive() {
            if (this.vehicle.hide_on_test_drive_form == 0 && this.vehicle.type != 1) {
                return true;
            }
            return false;
        },
    },
    methods: {
        customEvent,
        analyticsEvent({ category, action, label }, event = null) {
            customEvent({
                category: category,
                action: action,
                label: label
            });

            window.location = this.navigateToTarget(event.target);
        },
        navigateToTarget(target, depth = 0) {
            if (depth > 5) {
                return;
            }

            if (target.tagName === 'A') {
                return target.href;
            }

            return this.navigateToTarget(target.parentElement, depth + 1);
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('match-height');
        });
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/our-range/FinanceVehicleCard.vue